export const isFullScreen = state => state.isFullScreen;
